import React from "react";

export function GraphIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="107.79" className="st0" width="134.737" height="377.263" fill="rgb(75, 75, 75)" />
            <rect x="377.263" y="215.579" className="st0" width="134.737" height="269.474" fill="rgb(75, 75, 75)" />
            <rect x="188.632" y="26.947" className="st0" width="134.737" height="458.105" fill="rgb(75, 75, 75)" />
        </svg>
    );
}
